import React from 'react';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { useApexAdminPortalStateContext, useApexAdminPortalDispatchContext } from '../../ApexAdminPortalContext';
import { refreshInvestigationResource } from '../../ApexAdminPortalActions';
import View from './View';

const Files = () => {
  const { investigationResource } = useApexAdminPortalStateContext();
  const apexAdminPortalDispatch = useApexAdminPortalDispatchContext();
  const [showAttachFileModal, setShowAttachFileModal] = React.useState(false);
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Files' });

  const getDocuments = () => investigationResource.attr('documents')?.resources()?.list().map((document) => {
    return {
      resource: document,
      fileURL: document.relationship('download').link('related').url(),
      fileName: document.attr('name'),
      createdAt: document.attr('uploadedAt'),
      createdBy: document.attr('createdBy'),
    };
  });

  if (!investigationResource) {
    return null;
  }

  return (
    <View
      documents={getDocuments()}
      investigationURL={investigationResource.link('self').url()}
      onClickShowAttachFileModal={() => {
        setShowAttachFileModal(true);
        logEvent('Click Upload Document');
      }}
      showAttachFileModal={showAttachFileModal}
      onCloseAttachFileModal={() => {
        setShowAttachFileModal(false);
        refreshInvestigationResource(investigationResource, apexAdminPortalDispatch)
          .catch(err => displayErrorMessage(err, err.errors));
      }}
      amplitudeRootNodeProps={rootNodeProps}
    />
  );
};

export default Files;
